import { type PropsWithChildren } from "react";
import { RouterProvider } from "react-aria-components";
import { router } from "@inertiajs/react";

declare module "react-aria-components" {
    interface RouterConfig {
        routerOptions: {
            preserveState?: boolean;
            replace?: boolean;
            preserveScroll?: boolean;
            only?: string[];
        };
    }
}

export const RouteProvider = ({ children }: PropsWithChildren) => {
    return (
        <RouterProvider
            navigate={(to, options) => router.visit(to, options)}
            useHref={(href) => href}
        >
            {children}
        </RouterProvider>
    );
};
